// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"I8-z"};